import React, { FunctionComponent } from 'react';
import { filterByTypename } from '../../utils/graphql';
import { PageMetaContext } from '../../context/PageMetaContext';
import PAGE_TYPES from '../..//constants/pageTypes';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import useBasePageQuery from '../../hooks/useBasePageQuery';

const PageOwnerTitle: FunctionComponent = () => {
  const basePageData = useBasePageQuery();
  const { pageType } = useNotNullableContext(PageMetaContext);

  if (!basePageData.data?.page) {
    return null;
  }

  const { title, summary, owner, relationships } = basePageData.data.page;
  const beneficiaries = relationships?.beneficiaries;
  const charity = beneficiaries?.nodes
    ? filterByTypename(beneficiaries.nodes, 'Charity')
    : null;

  return (
    <>
      {pageType === PAGE_TYPES.CAMPAIGN && charity ? (
        <a
          className="jg-h5 jg-space-mbn jg-hero__owner-title"
          href={charity[0].profilePageUrl}
        >
          {charity[0].name}
        </a>
      ) : owner ? (
        <span className="jg-h5 jg-space-mbn jg-hero__owner-title">
          {owner.name}
        </span>
      ) : null}

      <h1 data-qa="page-owner-title">{title}</h1>
      <p
        data-qa="page-owner-summary"
        className="jg-text--light jg-pages-teams-charitysummary jg-space-mbn"
      >
        {summary ? summary[0].toUpperCase() + summary.slice(1) : null}
      </p>
    </>
  );
};

export default PageOwnerTitle;
